'use strict';
/**
 * This extracts the root domain. This is necessary to assign cookies to the correct domain so they show up anywhere.
 */

angular.module('msCore').service('domainSvc', ['$location', '$log', function ($location, $log) {
  var rootRegex = /(.*\.)?(.*\.[^:]*):?[0-9]*/;
  // split the first group on the dash
  var nonProdPrefixRegex = /(^\w+\-)+(.*\.).*\.[^:]*:?[0-9]*/;

  return {
    getRootDomain: getRootDomain,
    getDomainPrefix: getDomainPrefix,
    getSigninUrl: getSigninUrl,
    getUrlWithQueryParams: getUrlWithQueryParams,
    getRelativeUrl: getRelativeUrl,
    getBaseDomain: getBaseDomain,
    getUserDashboardDomain: getUserDashboardDomain,
    getAdminDomain: getAdminDomain,
    getAppDomain: getAppDomain,
    getAppV2Domain: getAppV2Domain,
    getFullyQualifiedRedirectUrl: getFullyQualifiedRedirectUrl
  };

  function getRootDomain() {
    var host = $location.host();
    var matches = rootRegex.exec(host);
    return matches && matches.length === 3 ? matches[2] : host;
  }

  function getDomainPrefix() {
    var host = $location.host();
    var matches = nonProdPrefixRegex.exec(host);
    return matches && matches.length === 3 ? matches[2] : '';
  }

  function getSigninUrl(queryParams) {
    var _url = 'https://' + getDomainPrefix() + getRootDomain() + '/api/v2/api/signin';
    return getUrlWithQueryParams(_url, queryParams);
  }

  function getUrlWithQueryParams(url, queryParams) {
    var _url = url;
    $log.debug('getUrlWithQueryParams - queryParams : ', queryParams);
    if (!queryParams) {
      $log.debug('getUrlWithQueryParams - no queryParams ');
      return _url;
    }
    var count = 0;
    for (var k in queryParams) {
      // only add params if they aren't falsy
      if (queryParams[k]) {
        var binder = count === 0 ? '?' : '&';
        _url = _url + binder + k + '=' + queryParams[k];
        count++;
      }
    }
    return _url;
  }

  function getRelativeUrl(relativeUrl) {
    return 'https://' + getDomainPrefix() + getRootDomain() + relativeUrl + document.location.search;
  }

  function getBaseDomain() {
    return 'https://' + getDomainPrefix() + getRootDomain();
  }

  function getUserDashboardDomain() {
    return 'https://' + (getDomainPrefix() ? 'dashboard-' + getDomainPrefix() : 'dashboard.') + getRootDomain();
  }

  function getAdminDomain() {
    return 'https://' + (getDomainPrefix() ? 'admin-' + getDomainPrefix() : 'admin.') + getRootDomain();
  }

  function getAppDomain() {
    var rootDomain = getRootDomain();
    // checking for localhost to allow for local development and cypress testing
    if (rootDomain === 'localhost') {
      return 'http://localhost:9099';
    }
    return 'https://' + (getDomainPrefix() ? 'app-' + getDomainPrefix() : 'app.') + getRootDomain();
  }

  function getAppV2Domain() {
    var rootDomain = getRootDomain();
    if (rootDomain === 'localhost') {
      return 'http://localhost:3030';
    }
    return 'https://' + (getDomainPrefix() ? 'appv2-' + getDomainPrefix() : 'appv2.') + rootDomain;
  }

  function getFullyQualifiedRedirectUrl(redirect) {
    var dashboardRedirectPrefix = '[user-dashboard]';

    //FUTURE - consider some scrubbing here to ensure redirects are same root domain?
    if (!_.startsWith(redirect, 'http')) {
      // Redirect users to user dashboard
      if (_.startsWith(redirect, dashboardRedirectPrefix)) {
        var urlSuffix = redirect.replace(dashboardRedirectPrefix, '');
        return getUserDashboardDomain() + urlSuffix;
      }
      return 'https://' + getDomainPrefix() + getRootDomain() + redirect;
    }
    //let fully qualified redirect URLs pass through
    return redirect;
  }
}]);